import { ENTITY_TYPES } from '@sales-center/common'
import { AttachmentsDrawer } from '@user/components/Attachments/AddAttachmentsDrawer'
import * as React from 'react'
import { LeadAttachmentsDrawerProps } from './typings'

export const LeadAttachmentsDrawer: React.FC<LeadAttachmentsDrawerProps> = (
  props,
) => {
  const {
    lead: { id },
    canUpdate,
    attachmentsOpen: open,
    onCloseAttachments: onClose,
  } = props

  return (
    <AttachmentsDrawer
      entityType={ENTITY_TYPES.Lead}
      entityId={id}
      canUpdate={canUpdate}
      open={open}
      onClose={onClose}
    />
  )
}
LeadAttachmentsDrawer.displayName = 'LeadAttachmentsDrawer'
